import App from "../app";
import { AddFiltersEvent, ClearFiltersEvent, FilterLinkEvent, RemoveFiltersEvent, SetFiltersEvent, ToggleFiltersEvent } from "../events";
import { FilterValue } from "../lib/filter";
import { ListItem } from "../model/datasource/list";
import Controller from "./controller";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";

export class FilterController<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends Controller<P, A, Z, I> {
	bind(target: EventTarget, app: App<P, A, Z, I>): void {
		target.addEventListener(ToggleFiltersEvent.type, (e: ToggleFiltersEvent) => this.toggleFilters(app, e.detail));
		target.addEventListener(AddFiltersEvent.type, (e: AddFiltersEvent) => this.addFilters(app, e.detail));
		target.addEventListener(RemoveFiltersEvent.type, (e: RemoveFiltersEvent) => this.removeFilters(app, e.detail));
		target.addEventListener(ClearFiltersEvent.type, () => this.clearFilters(app));
		target.addEventListener(SetFiltersEvent.type, (e: SetFiltersEvent) => this.setFilters(app, e.detail));
		target.addEventListener(FilterLinkEvent.type, (e: FilterLinkEvent) => this.setFilterLink(app, e.detail));
	}

	toggleFilters(app: App<P, A, Z, I>, filters: string[]): void {
		app.filter.toggle(filters);
		app.navigation.updateFilters(app.filter.getIDs());
		this.update(app);
	}

	addFilters(app: App<P, A, Z, I>, filters: string[]): void {
		app.filter.add(filters);
		app.navigation.updateFilters(app.filter.getIDs());
		this.update(app);
	}

	removeFilters(app: App<P, A, Z, I>, filters: string[]): void {
		app.filter.remove(filters);
		app.navigation.updateFilters(app.filter.getIDs());
		this.update(app);
	}

	clearFilters(app: App<P, A, Z, I>): void {
		app.filter.clear();
		app.navigation.updateFilters(app.filter.getIDs());
		this.update(app);
	}

	setFilters(app: App<P, A, Z, I>, filters: string[]): void {
		app.filter.set(filters);
		this.update(app);
	}

	setFilterLink(app: App<P, A, Z, I>, element: HTMLAnchorElement) {
		const url = new URL(element.href);
		url.searchParams.delete("filter");
		for (const filter of app.filter.getIDs()) {
			url.searchParams.append("filter", filter);
		}
		element.href = url.toString();
	}

	update(app: App<P, A, Z, I>): void {
		const bindTarget: EventTarget = app.view.getBindTarget();
		const activeFilters: FilterValue[] = app.filter.getValues();
		app.view.list.displayFilters(activeFilters, bindTarget);
		app.model.list.getItemList().then((items: ListItem<I>[]) =>
			app.model.list.getFilteredItems(items, activeFilters)
		).then((filtered: ListItem<I>[]) => {
			const active: number[] = app.current.setActive(filtered);
			app.view.list.displayFiltered(active);
			const current: number = app.current.get();
			const prevTest: number = app.current.getAdjacent(-1);
			const nextTest: number = app.current.getAdjacent(1);
			app.view.header.displayPrevious(prevTest !== current);
			app.view.header.displayNext(nextTest !== current);
			app.view.header.displayPosition(
				app.current.getPosition(),
				app.current.getVisible().length
			);
		});
	}
}